import { store } from "@betacrew/jars-flux";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { componentKey, setIsAllCheckBoxChecked, setIsCheckBoxChecked, setLoadingState, setPaginationState, setPayerPaymentList, setPayersPaymentDetails, setScheduleDate } from "./SubmitFormForMultiplePayersSlice";
import { PAGE_STATE } from "../../../constants/constants";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { setSubmitForThisPayerModal, setSubmitFormFees, setSubmitFormForMultiplePayers } from "../FormListingSlice";
import DateUtils from "../../../../../libs/utility/DateUtils";
import { CHECKBOX_FIELD_NAMES } from "./constants";
import General from "../../../../../libs/utility/General";

export const { getSubmitAllPayersGridList, getListofAllPayersPaymentDetails, setCheckboxSubmitForAllPayer } = {
    getSubmitAllPayersGridList: (payload) => {
        return {
            type: "GET_LIST_OF_ALL_PAYERS_PAYMENT",
            payload
        }
    },

    getListofAllPayersPaymentDetails: (payload) => {
        return {
            type: "GET_LIST_OF_ALL_PAYERS_PAYMENT_DETAILS",
            payload
        }
    },

    setCheckboxSubmitForAllPayer: (payload) => {
        return {
            type: "SUBMIT_FOR_MULTIPLE_PAYERS/SET_CHECKBOX_SUBMIT_FOR_ALL_PAYER",
            payload
        }
    },
}

function* getSubmitAllPayersGridListAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading..." }))

        const { FormNameId, FormName, TaxYear, FormStatus } = action?.payload;

        const data = {
            formId: FormNameId,
            formType: "Original",
            taxyear: TaxYear,
            formname: FormName,
            statustype: FormStatus
        }
        const restResponse = yield SubmitFormsDataService.resetCascadePayersForGridCache();

        if( restResponse?.State || restResponse.State === 0) {
            yield put(addNotifications({ heading: "Failed to reset payers", message: Message }));
        } else {
            const response = yield SubmitFormsDataService.getSubmitAllPayersGridList(data);
            const { Message, Status, Data } = response?.data;
    
            if (Status) {
                yield put(setPayerPaymentList(Data));
                yield put(setScheduleDate(Data[0]?.SheduledDate))
                yield put(setPaginationState({ totalPayer: Data?.length }))
            } else {
                yield put(addNotifications({ heading: "Failed to fetch payer list", message: Message }));
                yield put(setSubmitFormForMultiplePayers(false));
            }
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch payer list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* getListofAllPayersPaymentAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }))

        const { FormNameId, TaxYear, FormStatus, ScheduleDate } = action?.payload;

        const data = {
            FormNameId: FormNameId,
            TaxYear: TaxYear,
            FormStatus: FormStatus,
            ScheduleDate: DateUtils.dateFormatter(ScheduleDate, "MM/DD/YYYY"),
            IsSuppressWarnings: false,
            IsCorrected: false
        }
        const response = yield SubmitFormsDataService.getListofAllPayersPayment(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            let detailedObj = {
                "OnlySeparateStatefiling": "false",
                "TotalFilingFee": General.getNumberAmount(Data.TotalFilingFee),
                "FilingFee": General.getNumberAmount(Data.FilingFee),
                "USPSFee": General.getNumberAmount(Data.MailingFee),
                "TINMatchFee": General.getNumberAmount(Data.TinMatchFee),
                "StateFee": General.getNumberAmount(Data.StateFilingFee),
                "TINCount": "0",
                "eDeliveryFee": General.getNumberAmount(Data.eDeliveryFee),
                "StateFilingCount": "0",
                "USPSCount": "0",
                "FormCount": Data.TotalFormCount,
                submitForMultiplePayers: true
            }

            if(Data?.DiscountCode){
                detailedObj = {
                    ...detailedObj,
                    "DiscountCode": Data.DiscountCode,
                }
            }

            yield put(setSubmitFormFees(detailedObj));
            yield put(setPayersPaymentDetails(Data));
            yield put(setSubmitFormForMultiplePayers(false))
            yield put(setSubmitForThisPayerModal(true))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch payer payment details", message: Message }));
            yield put(setSubmitFormForMultiplePayers(false));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch payer payment details", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* setCheckboxSubmitForAllPayerAsync(action) {
    const { name, checked, index, payer, taxYear, formId, formStatus, formName } = action.payload;
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }));


        const response = yield SubmitFormsDataService.setCheckboxSubmitForAllPayer({ 
            "FormId": formId,
            "Taxyear": taxYear,
            "FieldName": name.replace(CHECKBOX_FIELD_NAMES.IS_TIN_CHECK, CHECKBOX_FIELD_NAMES.IS_TIN_MATCH),
            "IsChecked": checked,
            "PayerId": payer
         });

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if(index >= 0) {
                yield put(setIsCheckBoxChecked({ name, checked, index }));
            }
        } else {
            yield put(addNotifications({ heading: "Failed to update payer options", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to update payer options", message: error?.response?.data?.Message }));
        yield put(setSubmitFormForMultiplePayers(false));
    } finally {
        if(index >= 0) {
            yield put(setIsCheckBoxChecked({ name, checked, index }));
        } else {
            yield put(setIsAllCheckBoxChecked({ name, checked }));
        }
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getSubmitAllPayersGridList().type, getSubmitAllPayersGridListAsync),
        takeLatest(getListofAllPayersPaymentDetails().type, getListofAllPayersPaymentAsync),
        takeLatest(setCheckboxSubmitForAllPayer().type, setCheckboxSubmitForAllPayerAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);